"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.RootContent=void 0;var t;(function(o){o.CollectionGroups="CollectionGroups",o.Collections="Collections",o.Products="Products"})(t||(exports.RootContent=t={}));
//# sourceMappingURL=RootContent.js.map
